import {
  MarketAccessory,
  MarketActionCard,
  MarketButton,
  MarketHeader,
  MarketList,
  MarketRow,
} from '@market/react';
import { useDispatch, useSelector } from 'react-redux';
import { view } from '@squareup/sq-addons-web-sdk';
import { ReactComponent as ExclamationCircle } from '@market/icons/assets/svg/exclamation-circle.svg';
import { useHistory } from 'react-router-dom';
import { removeDiscountNamePrefix } from 'utils/discount';

import {
  removeDiscountsStateSelector,
  updatedDiscountsSelector,
} from 'store/discounts';
import * as discountsActions from 'store/discounts/actions';
import { useEffect } from 'react';
import qs from 'qs';

const InvalidDiscountsScreen = () => {
  const queryParams = qs.parse(window.location.search, {
    ignoreQueryPrefix: true,
  });
  const hasCheckingOut = queryParams['checking_out'] === 'true';

  const dispatch = useDispatch();
  const history = useHistory();

  const updatedDiscounts = useSelector(updatedDiscountsSelector);

  const removeDiscountsState = useSelector(removeDiscountsStateSelector);

  const removeDiscounts = () => {
    const discountIdsToRemove = [updatedDiscounts]
      .flat()
      .map((discount) => discount.uid!);

    dispatch(discountsActions.removeDiscounts(discountIdsToRemove));
  };

  useEffect(() => {
    if (removeDiscountsState.success) {
      dispatch(discountsActions.resetRemoveDiscounts());
      if (hasCheckingOut) {
        view.continueClicked();
      } else {
        history.replace('/customer' + history.location.search);
      }
    }
  }, [dispatch, removeDiscountsState.success, hasCheckingOut, history]);

  return (
    <div className="market-grid-container">
      <MarketHeader className="market-grid-item-full">
        <h2>Rewards have changed for this sale</h2>
        <div style={{ marginBottom: '40px' }}>
          <p>
            Changes have been made to this sale, so some rewards may have
            changed or become unavailable.
          </p>
        </div>
      </MarketHeader>
      <MarketList
        className="market-grid-item-full"
        data-testid="invalid-discounts-list"
      >
        {updatedDiscounts.map((discount) => {
          return (
            <MarketActionCard key={discount.name} value={discount.name}>
              <MarketRow data-testid={`${discount.name}-card`}>
                <MarketAccessory
                  slot="leading-accessory"
                  size="image"
                  className="addons-warning-icon-container"
                >
                  <ExclamationCircle
                    width="24"
                    height="24"
                    className="addons-warning-icon"
                  />
                </MarketAccessory>
                <label slot="label">
                  {removeDiscountNamePrefix(discount.name)}
                </label>
                <div slot="subtext">Amount has changed</div>
              </MarketRow>
            </MarketActionCard>
          );
        })}
      </MarketList>
      <MarketButton
        data-testid="finish-btn"
        className="market-grid-item-full"
        isLoading={removeDiscountsState.isPending || undefined}
        onClick={() => removeDiscounts()}
        rank="primary"
      >
        {hasCheckingOut ? 'Return to current sale' : 'Continue'}
      </MarketButton>
    </div>
  );
};

export default InvalidDiscountsScreen;
